import React from 'react';

import { PackagesSubspaceRouter } from '~src/packages/components/PackagesSubspaceRouter';
import { subspaceStyle } from '~src/settings/styles/CommonStyles';

export function PackagesSiteSettingsSubspace(): React.ReactElement {
  return (
    <div className={subspaceStyle}>
      <PackagesSubspaceRouter />
    </div>
  );
}
